module.exports = __webpack_public_path__ + "prod/20260903163609/img/officialAccount.85b10ff1.jpg";